export const structuredData = () => {

    const hostname = `${window.location.protocol}//${window.location.hostname}`;
    let data = {
        "@context": "https://schema.org",
        "@graph":
        [
            { "@type": "SiteNavigationElement", "url": `${hostname}/photobooks`, "name": "Photo Books" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/flushmount`, "name": "Flush Mount Albums" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/canvas-prints`, "name": "Canvas Prints" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/invitationcards`, "name": "Custom Cards" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/prints`, "name": "Photo Prints" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/promotions`, "name": "Photobook Promotions" },
            { "@type": "SiteNavigationElement", "url": `${hostname}/photo-gifts`, "name": "Photo Gifts" }
        ]
    }

    return JSON.stringify(data);
};



// WEBPACK FOOTER //
// ./src/Common/SEO/structuredData.js